module.exports = __webpack_public_path__ + "static/media/icon.b5950e55.png";